/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  LeadStatus,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const UpdateProspectAnalyticsIdentifierParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainSessionId: DomainSessionId,
  domainUserId: DomainUserId,
  leadStatus: LeadStatus.nullable(),
});

export type UpdateProspectAnalyticsIdentifierParameters = z.infer<
  typeof UpdateProspectAnalyticsIdentifierParameters
>;
